<div class="mb-3 is-relative" #typeahead>
  <div [formGroup]="form()">
    <div class="has-float-label is-flex">
      <input
        class="input"
        [class.is-danger]="hasDanger"
        [class.has-value]="hasValue"
        (keydown)="onKeyDown($event)"
        [formControlName]="controlName()"
        (input)="typing()"
        [attr.data-testid]="controlName()"
        [mask]="mask()"
        (focus)="onFocus()"
        (blur)="onBlur()"
      />
      <div class="flex pt-3 is-justify-content-flex-end typeahead-loading-spinner-container">
        @if (loading()) {
          <fino-icon
            icon="Loading Half"
            class="has-text-primary loading-spinner has-click is-spinning typeahead-loading-spinner"
          ></fino-icon>
        }
        @if (!loading() && hasValue) {
          <fino-icon
            (click)="copyToClipboard()"
            icon="Copy Paste 1"
            class="has-text-primary loading-spinner click-pop has-click typeahead-loading-spinner"
          ></fino-icon>
        }
      </div>

      <label class="label" [translate]="label() || controlName()"></label>
    </div>
    @if (results?.length > 0 && showResults()) {
      <div class="box typeahead-results-container">
        <div class="is-flex is-justify-content-flex-end pr-2 pt-1 typeahead-header">
          <fino-icon
            (click)="hideResults()"
            data-testid="closeTypeahead"
            icon="Close"
            class="has-text-grey is-small has-click"
          ></fino-icon>
        </div>
        @for (result of results; track result; let i = $index) {
          <div
            class="typeahead-result mb-2"
            [class.has-background-grey-lighter]="i === selectedIndex() && canNavigateByKeys()"
          >
            <ng-container *ngTemplateOutlet="resultTemplate(); context: { $implicit: result }">
            </ng-container>
          </div>
        }
      </div>
    }
    @if (results?.length == 0 && showResults() && !loading() && hasValue && hasFocus()) {
      <div class="box typeahead-results-container">
        <div class="is-flex is-justify-content-flex-end pr-2 pt-1 typeahead-header">
          <fino-icon
            (click)="hideResults()"
            data-testid="closeTypeahead"
            icon="Close"
            class="has-text-grey has-click is-small"
          ></fino-icon>
        </div>
        <div
          class="result pb-3 pt-3 is-flex is-justify-content-center has-text-weight-bold"
          translate="typeahead.noResults"
        ></div>
      </div>
    }
    @if (hasDanger) {
      <div class="has-text-left">
        <div class="help is-danger">{{ error | translate }}</div>
      </div>
    }
  </div>
</div>
